'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import styles from './SampleCarouselControls.module.scss';
type SampleCarouselControlsProps = {
  onPrev: () => void;
  onNext: () => void;
  size?: 'default' | 'sm';
};
export function SampleCarouselControls(t0) {
  const $ = _c(22);
  const {
    onPrev,
    onNext,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const buttonSize = size === "sm" ? 44 : 56;
  const iconSize = size === "sm" ? 22 : 28;
  const gap = size === "sm" ? 12 : 16;
  let t2;
  if ($[0] !== gap) {
    t2 = {
      gap
    };
    $[0] = gap;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== buttonSize) {
    t3 = {
      width: buttonSize,
      height: buttonSize
    };
    $[2] = buttonSize;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== iconSize) {
    t4 = <Image src="/intro/sample_left_button.svg" alt="" width={iconSize} height={iconSize} className={styles.icon} />;
    $[4] = iconSize;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onPrev || $[7] !== t3 || $[8] !== t4) {
    t5 = <button type="button" onClick={onPrev} aria-label="Previous template" className={styles.button} style={t3}>{t4}</button>;
    $[6] = onPrev;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== buttonSize) {
    t6 = {
      width: buttonSize,
      height: buttonSize
    };
    $[10] = buttonSize;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== iconSize) {
    t7 = <Image src="/intro/sample_right_button.svg" alt="" width={iconSize} height={iconSize} className={styles.icon} />;
    $[12] = iconSize;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onNext || $[15] !== t6 || $[16] !== t7) {
    t8 = <button type="button" onClick={onNext} aria-label="Next template" className={styles.button} style={t6}>{t7}</button>;
    $[14] = onNext;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t8) {
    t9 = <div className={styles.container} style={t2}>{t5}{t8}</div>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}